// extracted by mini-css-extract-plugin
export default {"container":"text-module__container--26kLM","text":"text-module__text--3Sv88","link":"text-module__link--3GjwU"};